import React, { createContext, useContext, useState } from "react";

const TabContext = createContext();

export function TabProvider({ children, defaultTab = "1" }) {
  // Persist selectedTab in sessionStorage
  const getInitialTab = () => {
    return sessionStorage.getItem("lastTimesheetTab") || defaultTab;
  };
  const [selectedTab, setSelectedTabState] = useState(getInitialTab());

  const setSelectedTab = (tab) => {
    setSelectedTabState(tab);
    sessionStorage.setItem("lastTimesheetTab", tab);
  };

  return (
    <TabContext.Provider value={{ selectedTab, setSelectedTab }}>
      {children}
    </TabContext.Provider>
  );
}

export function useTab() {
  const context = useContext(TabContext);
  if (!context) {
    throw new Error("useTab must be used within a TabProvider");
  }
  return context;
}
